import { IconBlanketPo } from '@procurify/ui'
import { Icon, Space, SubText } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type OrderItemType, OrderItemTypes } from '@webapp/models/enums'
import messages from './messages'
import { OrderItemTypeTagStyled } from './styles/OrderItemTypeTagStyled'

export interface IOrderItemTypeTagProps {
  itemType: OrderItemType
}

export const OrderItemTypeTag = ({ itemType }: IOrderItemTypeTagProps) => {
  const intl = useProcurifyIntl()

  const getIcon = (type: OrderItemType) => {
    switch (type) {
      case OrderItemTypes.RECURRING:
        return <Icon icon='action-history' size={18} />
      case OrderItemTypes.BLANKET:
        return <IconBlanketPo />
      default:
        return ''
    }
  }

  const getLabel = (type: OrderItemType) => {
    switch (type) {
      case OrderItemTypes.RECURRING:
        return (
          <SubText inline>
            {intl.formatMessage(messages.isRecurringOrderItem)}
          </SubText>
        )
      case OrderItemTypes.BLANKET:
        return (
          <SubText inline>
            {intl.formatMessage(messages.isBlanketOrderItem)}
          </SubText>
        )
      default:
        return ''
    }
  }

  return getLabel(itemType) ? (
    <OrderItemTypeTagStyled>
      <Space direction='horizontal' size='xsmall' align='start'>
        {getIcon(itemType)}
        {getLabel(itemType)}
      </Space>
    </OrderItemTypeTagStyled>
  ) : null
}

OrderItemTypeTag.displayName = 'OrderItemTypeTag'
